module.exports = __webpack_public_path__ + "static/media/vite.97810576.svg";